export function allObjectValuesEmpty(object) {
    for (let value of Object.values(object)) {
        if (value !== "") {
            return false;
        };
    };
    return true;
};